import React from 'react';
import { observer } from 'mobx-react';
import {
  RouteComponentProps, Switch, Route
} from "react-router-dom";
import IndexChatBotLog from './IndexChatBotLog';
import ViewChatBotLog from './ViewChatBotLog';

interface ChatBotLogProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class ChatBotLog extends React.Component<ChatBotLogProps> {
  render() {
    const { path } = this.props.match;
    return (
      <Switch>
        <Route exact path={path}
          render={(props) => (
            <IndexChatBotLog {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
        <Route exact path={`${path}/contrato/:contract_id`}
          render={(props) => (
            <ViewChatBotLog {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
      </Switch>
    )
  }
}
